var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"mb-0",staticStyle:{"cursor":"pointer"}},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.saving},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.toggle($event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }